(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radarshield-campaign"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rs-campaign')) {
    customElements.define(
      'rs-campaign',
      class extends HTMLElement {
        connectedCallback() {
          this.designMode = this.dataset.designMode === 'true';
          this.list = this.querySelector('.ls');
          this.onClick = this.onClick.bind(this);
          this.tick = this.tick.bind(this);
          this.addEventListener('click', this.onClick);
          if (!this.list) return;
          this.tick();
          this.timer = setInterval(this.tick, 1000);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.removeEventListener('click', this.onClick);
        }

        tick() {
          const now = Date.now() / 1000;

          this.querySelectorAll('.it').forEach((item) => {
            const end = Number(item.dataset.end) || 0;
            if (!end) return;

            // Remove expired campaigns even when the page is served from cache
            if (end <= now && !this.designMode) {
              item.remove();
              return;
            }

            const countdown = item.querySelector('[data-countdown]');
            if (countdown) countdown.textContent = this.format(Math.max(0, end - now));
          });

          const remaining = this.querySelectorAll('.it').length;
          this.list.dataset.count = remaining;
          if (remaining) return;

          // No campaigns left: keep the social panel on its own, or hide the whole section
          clearInterval(this.timer);
          if (this.querySelector('.so')) {
            this.querySelector('.pc')?.remove();
            this.querySelector('.gr')?.setAttribute('data-single', '');
          } else {
            (this.closest('.shopify-section') || this).hidden = true;
          }
        }

        format(seconds) {
          const d = Math.floor(seconds / 86400);
          const h = Math.floor((seconds % 86400) / 3600);
          const m = Math.floor((seconds % 3600) / 60);
          const s = Math.floor(seconds % 60);
          const pad = (n) => String(n).padStart(2, '0');
          return d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
        }

        async onClick(event) {
          const button = event.target.closest('[data-copy]');
          if (!button) return;

          const code = button.dataset.copy;
          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'absolute';
            input.style.left = '-9999px';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }

          const text = button.querySelector('[data-copy-text]');
          const status = button.parentElement.querySelector('[data-copy-status]');
          const original = text.textContent;
          text.textContent = button.dataset.copiedLabel;
          if (status) status.textContent = `${code} ${button.dataset.copiedLabel}`;
          clearTimeout(button._resetTimer);
          button._resetTimer = setTimeout(() => {
            text.textContent = original;
            if (status) status.textContent = '';
          }, 2000);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
